import { render, staticRenderFns } from "./FollowLanding.vue?vue&type=template&id=3992c7e3&scoped=true&"
import script from "./FollowLanding.vue?vue&type=script&lang=js&"
export * from "./FollowLanding.vue?vue&type=script&lang=js&"
import style0 from "./FollowLanding.vue?vue&type=style&index=0&id=3992c7e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3992c7e3",
  null
  
)

export default component.exports